<template>
  <div>
    <div class="container">
      <div class="row">
        <popUp v-if="referToggle===true" v-on:doClose="close">
          <div class="pop-title" slot="title">
            <h5>參考答案</h5>
            <div class="hori-line"></div>
            <br/>
          </div>
          <div slot="info" class="info-main px-2">
            <div>
              <audio controls controlsList="nodownload">
                <source :src="getVoiceFile(reference.voice)"  type="audio/mp3" />
              </audio>
              <hr/>
              <p>{{reference.text}}</p>
            </div>
          </div>
        </popUp>
        <popUp :size="popSize" v-if="toggle===true" v-on:doClose="close">
          <div class="pop-title px-2" slot="title">
            <h5>解析</h5>
            <div class="hori-line"></div>
            <br/>
            <!-- <h6 style="font-weight: bolder;">{{ answerDetail.title.text }}</h6>
            <h6 style="font-weight: bolder;">{{ answerDetail.title.translate }}</h6> -->
          </div>
          <div slot="info" class="info-main px-2">
            <div class="answerDetail-box" v-html="answerDetail"></div>
            <!-- <p>{{answerDetail.resolve}}</p>
            <div v-if="part!=='6'" v-for="(item, index) in answerDetail.detail" :key="index" class="p-3">
              <div class="d-flex align-items-center">
                <span class="detail-title" :class="{'answer': item.key === answer}">
                  答案: {{ item.key }}
                </span>
                <span class="mx-2">
                  <img style="width: 25px;" v-if="item.key === answer" src="../../assets/toeic/icon_TOEIC_answer_correct.png" alt=""  srcset="">
                  <img style="width: 25px;" v-else src="../../assets/toeic/icon_TOEIC_answer_wrong.png" alt=""  srcset="">
                </span>
              </div>
              <div class="detail-box p-3" :class="{'answer-border': item.key === answer}">
                <span>
                  {{ item.text }}
                </span>
                <br/>
                <span>
                  {{ item.translate }}
                </span>
              </div>
            </div> -->
          </div>
        </popUp>
        <div class="col-12 mb-3 d-flex align-items-center rwd-hide">
          <div class="mx-auto" style="text-align: center;">
            <img v-if="mode==='guide'" style="width:125px;" class="pointer mx-3" src="../../assets/toeic/btn_TOEIC_strategy_on.png" alt="" srcset="">
            <img @click="mode='guide'" style="width:125px;" v-else class="pointer mx-3" src="../../assets/toeic/btn_TOEIC_strategy_off.png" alt="" srcset="">
            <img @click="mode='practice'" style="width:125px;" v-if="mode==='guide'" class="pointer mx-3" src="../../assets/toeic/btn_TOEIC_practise_off.png" alt="" srcset="">
            <img v-else style="width:125px;" class="pointer mx-3" src="../../assets/toeic/btn_TOEIC_practise_on.png" alt="" srcset="">
          </div>
        </div>
        <div class="row" v-if="mode==='guide'">
          <div class="col-12">
            <div class="d-flex my-3">
              <h3 class="title pr-3">考前須知</h3>
              <div class="line"></div>
            </div>
            <div class="my-3">
              <div>
                <ul>
                  <li v-for="(item, index) in inputExam.description" :key="index">{{ item }}</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="d-flex my-3">
              <h3 class="title pr-3">解題技巧</h3>
              <div class="line"></div>
            </div>
            <div class="my-3">
              <div>
                <ul>
                  <li v-for="(item, index) in inputExam.solving_ability" :key="index">{{ item }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="container my-3" v-else>
          <h5>Directions  : </h5>
          {{ inputExam.description_en }}
          <!-- part1 -->
          <div v-if="localExam.part === 1" class="row my-5" v-for="(item, index) in localExam.questions" :key="index">
            <div class="col-md-8 d-md-flex">
              <div class="d-flex align-items-center color-box2" style="color:#fff;text-align:center;">
                <div class="mx-auto">
                  <p>{{ item.num }}</p>
                  <p>{{ item.sub_type }}</p>
                </div>
              </div>
              <div class="object-fit-container question-box ml-md-2">
                {{item.title}}
                <!-- <img class="ml-2 question-image" style="width:100%" :src="require(`@/assets/toeic/part1/image/${item.imageName}.jpg`)" alt="" srcset=""> -->
              </div>
            </div>
            <div class="col-md-4 py-2  align-self-center">
              <div class="d-flex ">
                <div>
                  <img v-if=" recording && current === item.num" style="width:50px;"  @click="stopCountdown()" class="pointer mx-3" src="../../assets/toeic/TOEICtypes_mic_on.png" alt="" srcset="">
                  <img v-else @click="startRecording(item)" style="width:50px;" class="pointer mx-3" src="../../assets/toeic/TOEICtypes_mic_off.png" alt="" srcset="">
                </div>
                <div>
                  <audio v-if="item.record" :ref="`recordPlayer_${item.num}`" :src="item.record"></audio>
                  <img v-if="!item.record" style="width:50px;" class=" mx-3" src="../../assets/toeic/TOEICtypes_voice_off.png" alt="" srcset="">
                  <img v-else @click="playRecord(item)" style="width:50px;" class="pointer mx-3" src="../../assets/toeic/TOEICtypes_voice_on.png" alt="" srcset="">
                </div>
                <button class="answer-btn btn" @click="openAnswerDetail(item.answerDetail)">
                  解析
                </button>
              </div>
            </div>
          </div>
          <!-- part2 -->
          <div v-if="localExam.part === 2" class="row my-5" v-for="(item, index) in localExam.questions" :key="index">
            <div class="col-md-8 d-md-flex">
              <div class="d-flex align-items-center color-box2" style="color:#fff;text-align:center;">
                <div class="mx-auto">
                  <p>{{ item.num }}</p>
                  <p>{{ item.sub_type }}</p>
                </div>
              </div>
              <div class="object-fit-container question-box ml-md-2">
                <img class="ml-2 question-image" style="width:100%" :src="require(`@/assets/toeic/part2/image/${item.imageName}.jpg`)" alt="" srcset="">
              </div>
            </div>
            <div class="col-md-4 py-2  align-self-center">
              <div class="d-flex mb-2 justify-content-between">
                <div>
                  <img v-if=" recording && current === item.num" style="width:50px;"  @click="stopCountdown()" class="pointer" src="../../assets/toeic/TOEICtypes_mic_on.png" alt="" srcset="">
                  <img v-else @click="startRecording(item)" style="width:50px;" class="pointer" src="../../assets/toeic/TOEICtypes_mic_off.png" alt="" srcset="">
                </div>
                <div>
                  <audio v-if="item.record" :ref="`recordPlayer_${item.num}`" :src="item.record"></audio>
                  <img v-if="!item.record" style="width:50px;" class=" mx-3" src="../../assets/toeic/TOEICtypes_voice_off.png" alt="" srcset="">
                  <img v-else @click="playRecord(item)" style="width:50px;" class="pointer mx-3" src="../../assets/toeic/TOEICtypes_voice_on.png" alt="" srcset="">
                </div>
                <button class="answer-btn btn" @click="openAnswerDetail(item.answerDetail)">
                  解析
                </button>
              </div>
              <button class="detail-btn btn py-2" @click="openReference(item.reference)">
                參考答案
              </button>
            </div>
          </div>
          <!-- part3 -->
          <div v-if="localExam.part === 3"  class="row my-5" v-for="(item, index) in localExam.questions" :key="index">
            <div class="col-12">
              <div class="object-fit-container question-box p-4">
                <div class="d-flex align-items-center">
                  <button type="button" @click="changeVoice(item, 'en')" class="btn btn-outline-danger" :class="{'active': item.currentVoice ==  'en'}">
                    <font-awesome-icon icon="volume-up" class="text-sm mr-2" />美英
                  </button>
                  <button type="button" v-if="item.audioName_au" @click="changeVoice(item, 'au')" class="btn btn-outline-danger mx-2" :class="{'active': item.currentVoice ==  'au'}">
                    <font-awesome-icon icon="volume-up" class="text-sm mr-2" />澳加
                  </button>
                  <audio :ref="`audioPlayer_${item.num}`" controls controlsList="nodownload" :id="item.currentVoice">
                    <source :src="item.audioSource"  type="audio/wav" />
                  </audio>
                </div>
                <h6>{{ item.title }}</h6>
              </div>
              <div>
                <div class="row my-4" v-for="(el, index) in  item.childs" :key="index">
                  <div class="col-md-8 d-md-flex" >
                    <div class="d-flex align-items-center color-box2" style="color:#fff; width:20%;text-align:center;">
                      <div class="mx-auto py-2">
                        <div>{{ el.num }}</div>
                        <!-- <p>{{ item.sub_type }}</p> -->
                      </div>
                    </div>
                    <div class="question-box ml-md-2 align-items-center p-2">
                      <audio controls controlsList="nodownload" >
                        <source :src="el.audioSource"  type="audio/wav" />
                      </audio>
                      <br/>
                      {{ el.title }}
                    </div>
                  </div>
                  <div class="col-md-4 py-2  align-self-center">
                    <div class="d-flex mb-2 justify-content-between">
                      <div>
                        <img v-if=" recording && current === el.num" style="width:50px;"  @click="stopCountdown()" class="pointer" src="../../assets/toeic/TOEICtypes_mic_on.png" alt="" srcset="">
                        <img v-else @click="startRecording(el)" style="width:50px;" class="pointer" src="../../assets/toeic/TOEICtypes_mic_off.png" alt="" srcset="">
                      </div>
                      <div>
                        <audio v-if="el.record"  :ref="`recordPlayer_${el.num}`" :src="el.record"></audio>
                        <img v-if="!el.record" style="width:50px;" class=" mx-3" src="../../assets/toeic/TOEICtypes_voice_off.png" alt="" srcset="">
                        <img v-else @click="playRecord(el)" style="width:50px;" class="pointer mx-3" src="../../assets/toeic/TOEICtypes_voice_on.png" alt="" srcset="">
                      </div>
                      <button class="answer-btn btn" @click="openAnswerDetail(el.answerDetail)">
                        解析
                      </button>
                    </div>
                    <button class="detail-btn btn py-2" @click="openReference(el.reference)">
                      參考答案
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- part4 -->
          <div v-if="localExam.part === 4"  class="row my-5" v-for="(item, index) in localExam.questions" :key="index">
            <div class="col-12">
              <h6>{{ item.title }}</h6>
              <div class="d-flex align-items-center">
                <button type="button" @click="changeVoice(item, 'en')" class="btn btn-outline-danger" :class="{'active': item.currentVoice ==  'en'}">
                  <font-awesome-icon icon="volume-up" class="text-sm mr-2" />美英
                </button>
                <button type="button" v-if="item.audioName_au" @click="changeVoice(item, 'au')" class="btn btn-outline-danger mx-2" :class="{'active': item.currentVoice ==  'au'}">
                  <font-awesome-icon icon="volume-up" class="text-sm mr-2" />澳加
                </button>
                <audio :ref="`audioPlayer_${item.num}`" controls controlsList="nodownload" :id="item.currentVoice">
                  <source :src="item.audioSource"  type="audio/wav" />
                </audio>
              </div>
              <div class="object-fit-container question-box ml-2">
                <img class="ml-2 question-image" style="width:100%" :src="require(`@/assets/toeic/part4/image/${item.imageName}.jpg`)" alt="" srcset="">
              </div>
              <div>
                <div class="row my-4" v-for="(el, index) in  item.childs" :key="index">
                  <div class="col-md-8 d-md-flex" >
                    <div class="d-flex align-items-center color-box2" style="color:#fff; width:20%;text-align:center;">
                      <div class="mx-auto py-2">
                        <div>{{ el.num }}</div>
                        <!-- <p>{{ item.sub_type }}</p> -->
                      </div>
                    </div>
                    <div class="question-box ml-md-2 align-items-center p-2">
                      <audio controls controlsList="nodownload" >
                        <source :src="el.audioSource"  type="audio/wav" />
                      </audio>
                      <br/>
                      {{ el.title }}
                    </div>
                  </div>
                  <div class="col-md-4 py-2  align-self-center">
                    <div class="d-flex mb-2 justify-content-between">
                      <div>
                        <img v-if=" recording && current === el.num" style="width:50px;"  @click="stopCountdown()" class="pointer" src="../../assets/toeic/TOEICtypes_mic_on.png" alt="" srcset="">
                        <img v-else @click="startRecording(el)" style="width:50px;" class="pointer" src="../../assets/toeic/TOEICtypes_mic_off.png" alt="" srcset="">
                      </div>
                      <div>
                        <audio v-if="el.record"  :ref="`recordPlayer_${el.num}`" :src="el.record"></audio>
                        <img v-if="!el.record" style="width:50px;" class=" mx-3" src="../../assets/toeic/TOEICtypes_voice_off.png" alt="" srcset="">
                        <img v-else @click="playRecord(el)" style="width:50px;" class="pointer mx-3" src="../../assets/toeic/TOEICtypes_voice_on.png" alt="" srcset="">
                      </div>
                      <button class="answer-btn btn" @click="openAnswerDetail(el.answerDetail)">
                        解析
                      </button>
                    </div>
                    <button class="detail-btn btn py-2" @click="openReference(el.reference)">
                      參考答案
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- part5 -->
          <div v-if="localExam.part === 5"  class="row my-5" v-for="(item, index) in localExam.questions" :key="index">
            <div class="col-12">
              <div>
                <div class="row my-4">
                  <div class="col-md-8 d-md-flex" >
                    <div class="d-flex align-items-center color-box2" style="color:#fff; width:20%;text-align:center;">
                      <div class="mx-auto py-2">
                        <div>{{ item.num }}</div>
                        <!-- <p>{{ item.sub_type }}</p> -->
                      </div>
                    </div>
                    <div class="question-box ml-md-2 d-flex align-items-center ">
                      <div class="p-2">
                        <div class="d-flex align-items-center">
                          <!-- <button type="button" @click="changeVoice(item, 'en')" class="btn btn-outline-danger" :class="{'active': item.currentVoice ==  'en'}">
                            <font-awesome-icon icon="volume-up" class="text-sm mr-2" />美英
                          </button>
                          <button type="button" v-if="item.audioName_au" @click="changeVoice(item, 'au')" class="btn btn-outline-danger mx-2" :class="{'active': item.currentVoice ==  'au'}">
                            <font-awesome-icon icon="volume-up" class="text-sm mr-2" />澳加
                          </button> -->
                          <audio :ref="`audioPlayer_${item.num}`" controls controlsList="nodownload" :id="item.currentVoice">
                            <source :src="item.audioSource"  type="audio/mp3" />
                          </audio>
                        </div>
                        <div>
                          {{ item.title }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 py-2  align-self-center">
                    <div class="d-flex mb-2 justify-content-between">
                      <div>
                        <img v-if=" recording && current === item.num" style="width:50px;"  @click="stopCountdown()" class="pointer" src="../../assets/toeic/TOEICtypes_mic_on.png" alt="" srcset="">
                        <img v-else @click="startRecording(item)" style="width:50px;" class="pointer" src="../../assets/toeic/TOEICtypes_mic_off.png" alt="" srcset="">
                      </div>
                      <div>
                        <audio v-if="item.record"  :ref="`recordPlayer_${item.num}`" :src="item.record"></audio>
                        <img v-if="!item.record" style="width:50px;" class=" mx-3" src="../../assets/toeic/TOEICtypes_voice_off.png" alt="" srcset="">
                        <img v-else @click="playRecord(item)" style="width:50px;" class="pointer mx-3" src="../../assets/toeic/TOEICtypes_voice_on.png" alt="" srcset="">
                      </div>
                      <button class="answer-btn btn" @click="openAnswerDetail(item.answerDetail)">
                        解析
                      </button>
                    </div>
                    <button class="detail-btn btn py-2" @click="openReference(item.reference)">
                      參考答案
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div v-if="currentVoice!==''">
          <audio :id="currentVoice">
            <source :src="require(`@/assets/toeic/part${part}/voice/${currentVoice}.mp3`)" type="audio/mp3">
          </audio>
        </div> -->
        <button v-if="mode==='guide'" @click="goPage('practice') " type="button" class="btn btn-danger mx-auto">開始題型練習</button>
        <button v-else @click="goPage('guide')" type="button" class="btn btn-danger mx-auto">回到題型攻略</button>
      </div>
    </div>
  </div>
</template>

<script>
import popUp from '../../components/PopUp.vue'
import audioBufferToWav from 'audiobuffer-to-wav'
import AudioResampler from 'audio-resampler'

export default {
  name: 'Toeic-exam',
  components: {
    popUp
  },
  data () {
    return {
      mode: 'guide',
      toggle: false,
      referToggle: false,
      localExam: JSON.parse(JSON.stringify(this.inputExam)),
      answerDetail: null,
      reference: null,
      recording: false,
      audioUrl: null,
      current: 0,
      countdown: 0,
      isCounting: false,
      popSize: 'middle'
    }
  },
  props:{
    inputExam: {
      require: true
    }
  },
  computed: {
    part () {
      return this.$route.params.id
    }
  },
  watch: {
  },
  mounted () {
    this.localExam.questions.forEach(question => {
      this.$set(question, 'currentVoice', 'en')
      question.audioSource = require(`@/assets/toeic/part${this.part}/voice/${question.audioName_en}.wav`)
      if (question.childs) {
        question.childs.forEach(child => {
          this.$set(child, 'currentVoice', 'en')
          child.audioSource = require(`@/assets/toeic/part${this.part}/voice/${child.audioName_en}.wav`)
        })
      }
    })
  },
  methods: {
    selectAnswer (item, key) {
      this.$set(item, 'userAnswer', key)
    },
    changeVoice(question, type) {
      this.$set(question, 'currentVoice', type)
      try {
        question.audioSource = require(`@/assets/toeic/part${this.part}/voice/${type === 'en' ? question.audioName_en : question.audioName_au}.wav`)
      } catch (error) {
        console.error("Failed to load audio source:", error.message)
        return
      }
      this.$nextTick(() => {
        const audioRef = this.$refs[`audioPlayer_${question.num}`]
        const audio = Array.isArray(audioRef) ? audioRef[0] : audioRef
        if (audio) {
          this.pauseAll()
          audio.src = question.audioSource
          audio.load()
          audio.play().catch(error => {
            console.log("Audio play was interrupted: ", error.message)
          })
        } else {
          console.error("Audio element not found for:", question.num)
        }
      })
    },
    getVoiceFile (voiceName) {
      try {
        // 用 require() 動態引入時要使用相對於當前檔案的路徑
        return require(`@/assets/toeic/part${this.part}/voice/${voiceName}.mp3`)
      } catch (err) {
        console.error(`❌ 找不到音檔: part${this.part}/voice/${voiceName}.mp3`)
        return ''
      }
    },
    pauseAll () {
      let audios = document.getElementsByTagName('audio')
      const self = this
      const allAudios = []
      allAudios.forEach.call(audios, function (i) {
        i.currentTime = 0
        i !== self && i.pause()
      })
    },
    openAnswerDetail (el) {
      this.toggle = true
      this.answerDetail = el
    },
    openReference (el) {
      this.referToggle = true
      this.reference = el
    },
    playAudio(el) {
      if (!el) {
        console.error("No valid audio element provided.")
        return
      }
      let audio = document.getElementById(el)
      if (audio) {
        this.pauseAll()
        audio.load()
        audio.play()
      } else {
        console.error(`Audio element with id "${el}" not found.`)
      }
    },
    pauseAll () {
      let audios = document.getElementsByTagName('audio')
      const self = this
      const allAudios = []
      allAudios.forEach.call(audios, function (i) {
        i.currentTime = 0
        i !== self && i.pause()
      })
    },
    startCountdown (el) {
      this.isCounting = true
      this.doRecording(el)
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          this.stopCountdown()
        }
      }, 1000)
    },
    stopCountdown () {
      clearInterval(this.timer)
      this.stopRecording()
      this.isCounting = false
      this.recording = false
    },
    startRecording (el) {
      if (this.countdown === 0) {
        this.current = el.num
        console.log(el)
      }
      if (this.recording === true) {
        return
      }
      try {
        this.pauseAll()
        this.recording = true
        this.startTimer(el)
      } catch (e) {
        // alert(e)
        // this.stopAll()
      }
    },
    stopRecording() {
      if (this.mediaRecorder) {
        this.countdown = 0
        this.mediaRecorder.stop()
        this.recording = false
      }
    },
    startTimer (el) {
      this.countdown = 55
      this.startCountdown(el)
    },
    async doRecording(el) {
      this.$set(el, 'record', null)
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
        this.audioChunks = []
        this.mediaRecorder = new MediaRecorder(stream)
        const audioContext = new (window.AudioContext || window.webkitAudioContext)()
        const targetSampleRate = 16000;
        this.mediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            this.audioChunks.push(event.data)
          }
        }
        const vm = this
        this.mediaRecorder.onstop = async () => {
          const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' })

          const resampler = new AudioResampler(URL.createObjectURL(audioBlob), targetSampleRate, async function(event) {
            try {
              const audioBuffer = await event.getAudioBuffer ()
              const wavData = audioBufferToWav(audioBuffer)
              const wavBlob = new Blob([wavData], { type: 'audio/wav' })
              // vm.Upload(el,wavBlob)
            } catch (error) {
              console.error('Error:', error);
            }
          })
          const audioUrl = URL.createObjectURL(audioBlob)
          this.$set(el, 'record', audioUrl)
        }
        this.mediaRecorder.start()
        this.recording = true
      } catch (error) {
        console.error('錄音失敗：', error)
      }
    },
    playRecord (item) {
      console.log(item)
      const audioRef = this.$refs[`recordPlayer_${item.num}`]
      const audio = Array.isArray(audioRef) ? audioRef[0] : audioRef
      if (audio) {
        audio.play()
      }
    },
    close (close) {
      this.referToggle = close
      this.toggle = close
    },
    goPage (page) {
      this.mode = page
      this.stopCountdown()
      this.scrollTop()
    },
    scrollTop () {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/styles/custom.scss";
  .banner {
    height: 60vh;
    //background-image: url('../../assets/image/pic/banner_bg_toeic_top.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .title-box {
      width: 50%;
      .text-box {
        width: 50%;
        margin: auto;
        h4 {
          line-height: 200px;
          text-align: center;
          font-size: 150px;
          font-weight: 900;
          color: #fff;
          -webkit-text-stroke: 1.5px rgb(0, 0, 0);
        }
      }
    }
  }
  @media(max-width: 1080px){
    .banner {
      background-position: 0 0;
      .banner-box {
        display: none !important;
      }
    }
  }
  .container {
    text-align: left;
  }
  .object-fit-container {
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
  .main-title {
    font-weight: 800;
    color: $main-color;
  }
  .color-box1 {
    padding: 0 5px;
    min-width: 90px;
    background-color: #db9c4f;
  }
  .tips {
    list-style: none;
  }
  .color-box2 {
    padding: 0 5px;
    min-width: 90px;
    background-color: #ca6b3b;
  }
  .select-box {
    border: 1px solid rgb(73, 73, 73);
    border-radius: 2px;
    text-align:center;
    width: 100% !important;
  }
  .hori-line {
    width: 100%;
    height: 1px;
    margin-bottom: 10px;
    border-top: solid #2c3e50 1.5px;
  }
  .guide-box {
    //margin: auto;
    display: table;
    ul {
      margin-right: 15px;
      text-align: justify;
    }
  }
  .list-group-item {
    border-color: #2c3e50;
    h6 {
      font-weight: bold;
    }
  }
  .question-box {
    text-align: left;
    width: 100%;
    padding: 0 20px;
    border: 1px solid rgb(73, 73, 73);
  }
  .select-box:hover {
    background-color: rgb(212, 212, 212);
  }
  .correct-box {
    color: #328C12;
    background-color: #CEFFC6;
    border-color: #328C12 !important;
  }
  .wrong-box {
    color: #F30000;
    background-color: #FFC2C2;
    border-color: #F30000 !important;
  }
  .answer-btn {
    width: 100%;
    color: #3E439E;
    background-color: #D3E1FF;
    border: 1px solid;
    border-color: #3E439E !important;
    box-shadow: none !important;
  }
  .detail-btn {
    width: 100%;
    color: #fff;
    background-color: #DB9C4F;
    border: 1px solid;
    border-color: #db9137 !important;
    box-shadow: none !important;
  }

  .detail-title {
    width: 100px;
    text-align: center;
    padding: 5px;
    font-weight: 800;
    color: #F30000;
    background-color: #FFC2C2;
    border-radius: 5px 5px 0px 0px;
    border-width: 1px 1px 0 1px;
    border-style: solid;
    border-color: #F30000;
  }
  .answerDetail-box {
    height: 60vh;
    overflow-y: auto;
  }
  .answer {
    color: #328C12;
    border-color: #328C12;
    background-color: #CEFFC6;
  }
  .answer-border {
    border: 1px solid #328C12 !important;
  }
  .detail-box {
    border: 1px solid #F30000;
  }
  .title {
    font-size: 1.5rem;
    font-weight: 800;
    color: $main-color;
    background-color: $white-color;
    z-index: 10;
  }
  .line {
    width: 100%;
    position: absolute;
    // left: 100%;
    top: 32px;
    border-top: black 1px solid;
  }
  .rwd-show {
    display: none;
  }
  @media screen and (max-width: 420px) {
    .rwd-hide {
      display: none !important;
    }
    .rwd-show {
      display: block;
    }
    .banner {
      height: 30vh;
      background-size: contain;
      //background-image: url('../../assets/image/pic/banner_bg_toeic_top_SM_W.jpg');
    }
    .question-image {
      width: 100% !important;
    }
  }
</style>
